import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    initialize: function(options) {
        this.data = options.data;
    },

    render: function() {
        var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});

        if (!portal) {
            return this;
        }

        var html = '';

        var ideas = '';
        var total = 0;
        this.data.forEach(function(data) {
            var category = '';

            if (data.category) {
                data.category.split(',').forEach(function(category_name) {
                    category += '<a class="navigation primary font-weight-medium margin-left-12" href="/' + Cache.getDefaultProject().get('project_key') + '/feedback/?category=' + encodeURIComponent(category_name) + '">#' + Util.htmlEntities(category_name) + '</a>';
                });
            }

            var workflow = Cache.workflow.get(data.workflow);
            var workflow_name = '';
            if (workflow) {
                workflow_name = '<span class="workflow-badge" style="color:' + workflow.get('colour') + ';border-color:' + Util.hexToRgba(workflow.get('colour'), 0.4) + ';background-color:' + Util.hexToRgba(workflow.get('colour'), 0.04) + ';">' + workflow.escape('name') + '</span>';
            }

            ideas += '<tr>' +
                        '<td>' +
                            '<div class="font-weight-medium">' +
                                '<a class="no-underline hover-underline" href="' + portal.getUrl() + '/idea/' + data.id + '" target="portal">' + (Util.htmlEntities(data.title) || 'Untitled') + '</a>' +
                                (data.description ?
                                '<div class="text-info margin-top-4 margin-bottom-16" style="white-space:normal;">' + Util.htmlEntities(Util.trim(data.description, 100)) + '</div>' : '') +
                            '</div>' +
                            '<div class="text-info text-medium margin-top-8">' +
                                workflow_name +
                                '<span>' + category + '</span>' +
                            '</div>' +
                        '</td>' +
                        '<td>' +
                            '<span class="font-weight-medium">' +
                                (data.vote_count >= 1000 ? (data.vote_count / 1000).toFixed(1) + 'k' : data.vote_count) +
                            '</span>' +
                        '</td>' +
                    '</tr>';
            total++;
        });

        if (total < 5) {
            for (var i = 0; i < 5 - total; i++) {
                ideas += '<tr class="empty"><td colspan="2" height="70"></td></tr>';
            }
        }

        if (this.data.length) {
            html +=
            '<table class="medium">' +
                '<tr>' +
                    '<th width="85%">Feedback</th>' +
                    '<th width="15%">Vote</th>' +
                '</tr>' +
                ideas +
            '</table>';
        } else {
            var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});
            var portal_url = portal ? portal.getUrl() : '#';
            html += '<div class="text-info text-align-center italic" style="padding:80px 24px;">No ideas collected yet from your <a class="text-info" href="' + portal_url + '" target="portal">ideas portal<i class="fa-solid fa-up-right-from-square fa-xs margin-left-4"></i></a>.</div>';
        }

        this.$el.html(html);
        return this;
    }
});